<template>
    <v-content>
        <v-container grid-list-md text-xs-center>
            <v-layout row justify-space-around>
                <v-flex xs5 sm5 md5 lg5 xl5>
                  <v-card color="primary" elevation="20">
                    <h2 v-show="!isLoading" class="headings">Working Stock</h2>
                    <vc-donut
                        v-show="!isLoading"
                        background="#212121"
                        :size="200" unit="px" :thickness="30"
                        hasLegend legendPlacement="top"
                        :sections="sections" :total="totalWor"
                    >
                    </vc-donut>
                  </v-card>
                </v-flex>
                <v-flex xs5 sm5 md5 lg5 xl5>
                  <v-card color="primary" elevation="20">
                    <h2 v-show="!isDamLoading" class="headings">Damaged Stock</h2>
                    <vc-donut
                        v-show="!isDamLoading"
                        background="#212121"
                        :size="200" unit="px" :thickness="30"
                        hasLegend legendPlacement="top"
                        :sections="sectionsDam" :total="totalDam"
                    >
                    </vc-donut>
                  </v-card>
                </v-flex>
                <loading-component v-show="isLoading"></loading-component>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>
import { highValueData } from '../helpers/highValueHelper.js'
import loadingComponent from '../components/loadingSpinner.vue'

export default {
    components: {
        loadingComponent,
    },
    data() {
        return {
            sections: [],
            sectionsDam: [],
            totalWor: 100,
            totalDam: 100,
            isLoading: true,
            isDamLoading: true,
        }
    },
    watch: {
        sections: function () {
            this.totalWor = this.getTotal(this.sections)
            if (this.totalWor === 0) this.totalWor = 100
            this.isLoading = false
        },
        sectionsDam: function () {
            this.totalDam = this.getTotal(this.sectionsDam)
            if (this.totalDam === 0) this.totalDam = 100
            this.isDamLoading = false
        }
    },
    methods: {
        getSections() {
            highValueData('working').then((response) => {
                // console.log(response)
                this.sections = response
            })
            highValueData('damaged').then((response2) => {
                this.sectionsDam = response2
            })
        },
        getTotal(sections) {
            let sum = 0
            sections.forEach(element => {
                sum = sum + element.value
            });
            return sum
        },
    },
    created() {
        this.getSections()
    }
};
</script>

<style scoped>
.headings {
    background-color: transparent;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/highValueItemsView.vue